import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { MediaQueryEnum, useMediaQuery } from './commons/utils';

const GoogleRecaptcha: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isSp = useMediaQuery(MediaQueryEnum.sp);

  const recaptchaStyles = `
    .grecaptcha-badge {
      transform: ${isSp ? 'scale(0.7) translateX(-9%)' : 'scale(1)'};
    }
  `;

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}>
      <style>{recaptchaStyles}</style>
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default GoogleRecaptcha;
